import api from "../../../utils/api";

export const readCategories = async (params) => {
  const res = await api.get("/categories", { params });
  return res.data;
};
